export default __webpack_public_path__ + "static/media/InfoMainLogo.9bdc267a.svg";